import styled from 'styled-components'
import {breakpoints, media, mediaMax} from './theme/config'

export const Header = styled.header`
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  max-width: ${breakpoints.large};
  margin: 0 auto;
  z-index: 9999;
  
  * {
    box-sizing: border-box;
  }
  
  @media ${media.mobileL} {
    position: relative;
  }
`

export const Wrapper = styled.div`
  &:before {
    @media ${mediaMax.mobileL} {
      content: '';
      position: relative;
      display: block;
      width: 100%;
      height: ${({isSearchFlyoutOpen}) => (isSearchFlyoutOpen ? '146px' : '76px')};
      transition: height .15s ease-in-out;
    }
  }
`
